import { SimpleModel } from '@/models/base/SimpleModel';

export class PlaceChunk {
  public depth = 0;

  public place!: SimpleModel;
}
